import React from 'react';
import FaqArticleItemVideo from './FaqArticleItemVideo';
import { IArticleResponse } from './ICustomerService';

export interface ArticleVideosProps {
  article: IArticleResponse;
}

const ArticleVideos = ({ article }) => {
  return (
    <>
    {article?.Article.Videos.length > 0 && article?.Article.VideoCommonTitle !== null && (

      <div>
        <h4
          dangerouslySetInnerHTML={{ __html: article?.Article.VideoCommonTitle || '' }}
          className="customer-service-faq__faq-article__video-title"
        />
        <div className="customer-service-faq__faq-article__video-grid">
          {article?.Article.Videos.map((video) => (
            <FaqArticleItemVideo
              key={video.VideoUrl}
              VideoCommonTitle={article.Article.VideoCommonTitle}
              video={video}
            />
          ))}
        </div>
      </div>
      
    )}
    </>
  );
};

export default ArticleVideos;
